<template>
  <div 
    class="progressive-image-container" 
    :class="containerClass"
    :data-aos="dataAos"
  >
    <!-- 低清晰度占位图 -->
    <img
      v-if="!highResLoaded"
      :src="placeholderSrc"
      :alt="alt"
      :class="imageClass"
      class="progressive-image placeholder"
      :style="imageStyle"
    />
    <!-- 高清晰度图片 -->
    <img
      v-show="highResLoaded"
      :src="highResSrc"
      :alt="alt"
      :class="imageClass"
      class="progressive-image high-res"
      :style="imageStyle"
      @load="onHighResLoad"
      @error="onHighResError"
    />
    <!-- 加载指示器 -->
    <!-- <div v-if="showLoader && !highResLoaded && !loadError" class="loading-indicator">
      <div class="loading-spinner"></div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'ProgressiveImage',
  props: {
    // 高清图片路径
    highResSrc: {
      type: String,
      required: true
    },
    // 占位图片路径
    placeholderSrc: {
      type: String,
      required: true
    },
    // 图片alt属性
    alt: {
      type: String,
      default: ''
    },
    // 图片class
    imageClass: {
      type: String,
      default: ''
    },
    // 容器class
    containerClass: {
      type: String,
      default: ''
    },
    // 图片样式
    imageStyle: {
      type: Object,
      default: () => ({})
    },
    // 是否显示加载指示器
    showLoader: {
      type: Boolean,
      default: true
    },
    // AOS动画属性
    dataAos: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      highResLoaded: false,
      loadError: false,
      loadTimeout: null
    }
  },
  beforeDestroy() {
    // 清理定时器
    if (this.loadTimeout) {
      clearTimeout(this.loadTimeout)
    }
  },
  mounted() {
    // 确保占位图完全加载后再开始预加载高清图片
    const placeholderImg = new Image()
    placeholderImg.onload = () => {
      this.$nextTick(() => {
        setTimeout(() => {
          this.preloadHighResImage()
        }, 100)
      })
    }
    placeholderImg.src = this.placeholderSrc
  },
  methods: {
    preloadHighResImage() {
      if (this.highResLoaded || this.loadError) return
      
      const img = new Image()
      
      // 设置加载超时
      this.loadTimeout = setTimeout(() => {
        this.loadError = true
        this.$emit('error', new Error('图片加载超时'))
      }, 10000) // 10秒超时
      
      img.onload = () => {
        if (this.loadTimeout) {
          clearTimeout(this.loadTimeout)
          this.loadTimeout = null
        }
        this.highResLoaded = true
        this.$emit('loaded')
      }
      
      img.onerror = (error) => {
        if (this.loadTimeout) {
          clearTimeout(this.loadTimeout)
          this.loadTimeout = null
        }
        this.loadError = true
        this.$emit('error', error)
      }
      
      img.src = this.highResSrc
    },
    onHighResLoad() {
      if (!this.highResLoaded) {
        this.highResLoaded = true
        this.$emit('loaded')
      }
    },
    onHighResError(error) {
      if (!this.loadError) {
        this.loadError = true
        this.$emit('error', error)
      }
    }
  }
}
</script>

<style scoped>
.progressive-image-container {
  position: relative;
  display: inline-block;
  overflow: hidden;
}

.progressive-image {
  display: block;
  width: 100%;
  height: auto;
  transition: opacity 0.5s ease-in-out;
}

.progressive-image.placeholder {
  filter: blur(3px);
  opacity: 0.7;
  transform: scale(1.02);
}

.progressive-image.high-res {
  opacity: 0;
  animation: fadeIn 0.5s ease-in-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Banner图片特殊样式 */
.progressive-image-container.banner-container {
  position: relative;
  width: 100%;
  display: block; /* 覆盖默认的 inline-block，让容器占满整行 */
  overflow: hidden;
}

.progressive-image-container.banner-container .progressive-image {
  width: 100%;
  height: auto;
  display: block;
}

.progressive-image-container.banner-container .progressive-image.placeholder {
  position: relative;
}

.progressive-image-container.banner-container .progressive-image.high-res {
  position: relative; /* 改为文档流定位，让图片撑起容器高度 */
  width: 100%;
}
</style>